import { Link, useLocation } from "react-router-dom";
import {
  Users,
  Calendar,
  FileText,
  ClipboardList,
  LayoutDashboard,
  Landmark, // Bank ke liye
  Briefcase, // Experience ke liye
  Trophy,    // Skills ke liye
  Wallet     // Salary ke liye
} from "lucide-react";

export default function HrSidebar() {
  const { pathname } = useLocation();

  const menu = [
    {
      label: "Dashboard",
      path: "/hr/dashboard",
      icon: <LayoutDashboard size={18} />,
    },
    {
      label: "Employees",
      path: "/hr/employees",
      icon: <Users size={18} />,
    },
    {
      label: "Attendance",
      path: "/hr/attendance",
      icon: <Calendar size={18} />,
    },
    {
      label: "Leaves",
      path: "/hr/leaves",
      icon: <ClipboardList size={18} />,
    },
    {
      label: "Documents (KYC)",
      path: "/hr/documents",
      icon: <FileText size={18} />,
    },
    {
      label: "Skills",
      path: "/hr/skills",
      icon: <Trophy size={18} />,
    },
    {
      label: "Experiences",
      path: "/hr/experiences",
      icon: <Briefcase size={18} />,
    },
    {
      label: "Bank Details",
      path: "/hr/bank-details",
      icon: <Landmark size={18} />,
    },
    {
      label: "Salary Details",
      path: "/hr/salary-details",
      icon: <Wallet size={18} />,
    },
    {
      label: "Reports",
      path: "/hr/reports",
      icon: <ClipboardList size={18} />,
    },
  ];

  return (
    <aside className="w-64 bg-white border-r border-slate-200 h-screen fixed overflow-y-auto shadow-sm">
      <div className="p-5 text-xl font-bold text-indigo-600 sticky top-0 bg-white z-10">
        HR Panel
      </div>

      <nav className="px-3 pb-5 space-y-1">
        {menu.map((item) => {
          // Exact match ya sub-path match check karne ke liye
          const active = pathname.startsWith(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition group
                ${
                  active
                    ? "bg-indigo-600 text-white shadow-md shadow-indigo-200"
                    : "text-slate-700 hover:bg-slate-100"
                }
              `}
            >
              <span className={`${active ? "text-white" : "text-slate-400 group-hover:text-indigo-600"}`}>
                {item.icon}
              </span>
              {item.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}